<h3 class="modal-form-title">Add attachments</h3>
<ciao-file-upload [trip]="trip$ | async"></ciao-file-upload>
